import { BackendError, Service } from '@genial/services';
import { ResponsesStatementFundItemResponse } from '@genial/services/dist/models';
import { selectorFamily } from 'recoil';

import { advisorIdToApisSelector, partnerIdToApisSelector } from '../../../master/selector';
import { screenName } from '../../constants';
import { statementsFilterParamsState } from '../atom';
import { FundStatementsParamsProps } from '../types';

export const fundStatementsQuery = selectorFamily<
  | {
      data: ResponsesStatementFundItemResponse;
    }
  | null
  | undefined,
  { accountNumber: number; callEndpoint?: boolean }
>({
  key: 'CustomerDetail/fundStatementsQuery',
  get: ({ accountNumber, callEndpoint }) => {
    return async ({ get }) => {
      const responseEmpty = { data: {} as ResponsesStatementFundItemResponse };

      if (!callEndpoint) {
        return responseEmpty;
      }

      try {
        const params = get(statementsFilterParamsState) as FundStatementsParamsProps;
        const advisorSelected = get(advisorIdToApisSelector);
        const partnerSelected = get(partnerIdToApisSelector);

        const { data } = await Service.Finance.V1.getStatementByFundAccountNumber({
          ...params,
          screenName,
          advisorId: advisorSelected,
          partnerId: partnerSelected,
          accountNumber,
        });

        const response = { data: data?.fundStatement || responseEmpty.data };
        return response;
      } catch (error) {
        const backendError = error as BackendError;

        if (backendError.statusCode === 404) {
          return responseEmpty;
        }

        throw error;
      }
    };
  },
});
